import { render } from "./resetpassword.vue?vue&type=template&id=565f7e3d"
import script from "./resetpassword.vue?vue&type=script&lang=js"
export * from "./resetpassword.vue?vue&type=script&lang=js"

import "./resetpassword.vue?vue&type=style&index=0&id=565f7e3d&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__